import HelperMixin from "@/mixins/HelperMixin";
export default {
  name: "PpcBABoostCell",
  emits: ["boost-change"],
  mixins: [HelperMixin],
  props: {
    value: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      localBoost: "1",
      isBoostEdit: false
    };
  },
  computed: {
    boost: {
      get() {
        return this.localBoost;
      },
      set(value) {
        let newValue = value.replace(/[^0-9.]/g, "");
        const parts = newValue.split(".");
        if (parts.length > 2) {
          newValue = parts[0] + "." + parts.slice(1).join("");
        }
        this.localBoost = newValue;
      }
    }
  },
  methods: {
    onBoostEdit() {
      this.localBoost = this.convertBoost(this.value);
      this.isBoostEdit = true;
      this.$nextTick(() => {
        this.$refs.boost.focus();
      });
    },
    onBoostInput(event) {
      let value = event.target.value;
      this.boost = value;
    },
    onBoostBlur() {
      let value = parseFloat(this.boost);
      if (isNaN(value) || value <= 0) {
        value = 1;
      }
      this.$emit("boost-change", value);
      this.isBoostEdit = false;
    },
    onBoostKeydown(event) {
      this.isNumber(event);
      if (event.key === "Enter") {
        this.onBoostBlur();
      } else if (event.key === "Escape") {
        this.localBoost = this.value;
        this.isBoostEdit = false;
      }
    },
    convertBoost(value) {
      let strValue = value.toString();
      if (strValue.includes(".")) {
        const parts = strValue.split(".");
        if (parts[1].length > 1) {
          return parseFloat(value).toFixed(1);
        } else if (parts[1].length <= 1) {
          return strValue;
        }
      } else {
        return strValue + ".0";
      }
    }
  }
};